"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceType = exports.InstanceType = void 0;
const validation_1 = require("../validator/validation");
var InstanceType;
(function (InstanceType) {
    InstanceType["Sandbox"] = "SANDBOX";
    InstanceType["Developer"] = "DEVELOPER";
    InstanceType["Production"] = "PRODUCTION";
})(InstanceType = exports.InstanceType || (exports.InstanceType = {}));
exports.isInstanceType = (0, validation_1.isLiteral)(InstanceType.Sandbox, InstanceType.Developer, InstanceType.Production);
//# sourceMappingURL=instanceType.js.map